<template>
    <div class="index_container">
        <Header/>
        <Navigationzj :visible.sync="sOrh" :toptNavi="1"/>
        <div class="main-banner w1200">
            <div class="bd">
                <el-carousel :interval="5000" arrow="always" height="424px">
                    <el-carousel-item v-for="(item,index) in bannerList" :key="index">
                        <img :src="item.imgpath" width="700" height="424">
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="index_posinews">
                <div class="index_posinews_btn">
                    <a href="javascript: void(0);" style="color:#fff;" @click="enquiryType"><span>平台询价</span></a>
                    <!-- <router-link :to="{path:'/Resources'}" style="color:#fff;"><span>资源社区</span></router-link> -->
                </div>
                <div style="width: 240px;border: 1px solid #eee;border-right: none;background: #fff;">
                    <div class="index_posinews_info" style="width: 228px;margin: 0 auto;">
                        <div class="index_posinews_info_tit clearfix">
                            <span><router-link :to="{path:'/IndustryList'}"><img src="../../assets/images/kikiki.png"> <i style="color: #07357b;">行业</i>资讯</router-link></span>
                            <em><router-link :to="{path:'/IndustryList'}">MORE></router-link></em>
                        </div>
                        <div class="index_posinews_info_bottom">
                            <ul style="height: 255px;overflow: hidden;">
                                <li v-for="(item,index) in newsList" :key="index" style="padding:1px 10px;">
                                    <router-link target="_blank" :to="{path:'/InfoDetail',query:{id:item.id}}" class="clearfix" :title="item.title">
                                        <h3 style="width:100%">{{item.title}}</h3>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- <div class="index_posinews_info" style="width: 228px;height: 160px;margin: 8px auto 0;">
                        <div class="index_posinews_info_tit clearfix">
                            <span><a href=""><i style="color: #07357b;"><img src="../../assets/images/banner--pop01.png"> 新闻</i>公告</a></span>
                            <em><a href="">MORE></a></em>
                        </div>
                        <div class="index_posinews_info_bottom">
                            <ul style="height: 104px;overflow: hidden;">
                                <ul>
                                    <li v-for="item in 4" :key="item">
                                        <a target="_blank" href="" class="clearfix" title="">
                                            <h3>截取公告标题</h3>
                                        </a>
                                    </li>
                                </ul>
                            </ul>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <!-- 热门品牌 -->
        <!-- <div class="tj_index w1200 picScroll-left">
            <div class="tj_index_tit">
                <h3><router-link :to="{path:'/Brand'}" title="热门品牌">热门品牌</router-link></h3>
                <em>品质保证  安全保障</em>
            </div>
            <div class="clearfix">
                <div class="tj_index_l">
                    <img src="../../assets/images/zp_42.png" width="200" height="314">
                </div>
                <div class="bd tj_index_r" style="height: 315px;overflow: hidden;">
                    <div class="picList clearfix">
                        <el-carousel :interval="5000" arrow="always" height="315px">
                            <el-carousel-item v-for="(i,u) in brandCount" :key="u">
                                <div class="index_big">
                                    <ul class="clearfix">
                                        <li v-for="(item,index) in brandList.slice(u*15,15+(u*15))" :key="index">
                                            <router-link :to="{path:'/Ppxq', query:{bid:item.id}}">
                                                <img :src="item.img" width="200" height="103" :title="item.title">
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- 限时秒杀 -->
        <div v-show="showFlashsale" class="tj_index w1200 picScroll-left">
            <div class="clearfix">
                <div class="tj_index_l_skill">
                    <router-link :to="{path:'/Flashsale'}" target="_blank">
                        <div class="hotGoods-left-icon"></div>
                        <div class="hotGoods-left-time">
                            本场距结束还剩
                            <div class="t-wrap">
                                <span>
                                    <em>{{ day }}</em><i>天</i>
                                </span>
                                <span>
                                    <em>{{ hou }}</em><i>时</i>
                                </span>
                                <span>
                                    <em>{{ min }}</em><i>分</i>
                                </span>
                                <span>
                                    <em>{{ sec }}</em><i>秒</i>
                                </span>
                            </div>
                        </div>
                    </router-link>
                </div>
                <div class="bd tj_index_r_skill" style="height: 315px;overflow: hidden;">
                    <div class="picList clearfix">
                        <el-carousel :interval="5000" arrow="always" height="315px">
                            <el-carousel-item v-for="(i,u) in FlashCount" :key="u">
                                <div class="index_big_skill">
                                    <ul class="clearfix">
                                        <li v-for="(item,index) in FlashList.slice(u*4,4+(u*4))" :key="index">
                                            <div>
                                                <router-link :to="{path:'/GoodsDetail', query:{id:item.id}}">
                                                    <div class="img-box">
                                                        <img :src="item.imgpath" class="hot-img goodsfadeIn">
                                                    </div>
                                                    <div :title="item.title" class="goodsName">
                                                        {{ item.title }}
                                                    </div>
                                                    <div class="hot-price com-price">
                                                        <em class="p-price">
                                                            <i>￥</i>{{ item.sale_price }}
                                                        </em>
                                                        <em class="c-price">{{ item.tax_price }}</em>
                                                    </div>
                                                </router-link>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
            </div>
        </div>
        <!-- 场景采购 -->
        <div v-show="false" class="proindex_tj w1200">
            <div class="proindex_tj_tit">
                <img src="../../assets/images/zp_26.png">
                <!-- <router-link :to="{path:'/Hotcake'}" class="themore">更多>></router-link>
                <router-link :to="{path:'/Ledcontrol'}" class="themore">led>></router-link> -->
            </div>
            <div class="proindex_tj_con">
                <div class="clearfix">
                    <el-carousel :interval="5000" arrow="always" height="161px" :autoplay="false">
                        <el-carousel-item v-for="(i,u) in SceneCount" :key="u">
                            <div v-for="(item,index) in SceneList.slice(u*5,5+(u*5))" :key="index">
                                <div class="w234 fl">
                                    <div class="protj_two">
                                        <!-- <router-link :to="{path:'/Scenearea',query:{scene_id:item.id}}" class="clearfix" :title="item.title"> -->
                                        <a class="clearfix" :title="item.title" @click="zzjs()">
                                            <div class="title-content">
                                                <div class="title">{{item.title}}</div>
                                                <div class="sub-title">通用场景，品质之选</div>
                                            </div>
                                            <span>
                                                <img v-real-img="item.img" :alt="item.title" src="../../assets/images/zwtp.jpg" width="238px" height="161px">
                                            </span>
                                        </a>
                                        <!-- </router-link> -->
                                    </div>
                                </div>
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
        </div>
        <!-- 环保节能 维修专区 物联专区 行业资讯 -->
        <div v-show="false" class="proindex_tj w1200">
            <div class="">
                <div class="clearfix">
                    <ul class="repair">
                        <li>
                            <router-link :to="{path:'/Energy'}" target="_blank">
                                <img src="../../assets/images/energy.png" alt="环保节能">
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{path:'/Repair'}" target="_blank">
                                <img src="../../assets/images/cpwx.png" alt="维修专区">
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{path:'/Interthings'}" target="_blank">
                                <img src="../../assets/images/wlzq.png" alt="物联专区">
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{path:'/IndustryList'}" target="_blank">
                                <img src="../../assets/images/hyzx.png" alt="行业资讯">
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 楼层分布 -->
        <div style="background: #f8f8f8;margin-bottom: -60px;padding-bottom: 60px;">
            <div v-for="(item,index) in categoryGoods" :key="index" class="recommendation-section recommendations-for-nav w1200">
                <div class="recommendations">
                    <div class="recommend-each">
                        <!-- <div :class="index%2 === 0 ? 'recommend-brief' : index%3 === 0 ? 'recommend-brief recommend-briefred' : 'recommend-brief recommend-briefgreen'"> -->
                        <div class="recommend-brief" :class="'my_floor_img'+index">
                            <h2 class="title recommend-title">{{item.title}}</h2>
                            <ul class="list-group-row">
                                <li v-for="(chil,i) in item.children.slice(0,6)" :key="i">
                                    <router-link :to="{path:'/Classify',query:{parent_id:chil.id}}" :title="chil.title" target="_blank">
                                        {{chil.title}}
                                    </router-link>
                                </li>
                                <li><router-link :to="{path:'/Classify',query:{grand_id:item.id}}">查看全部</router-link></li>
                            </ul>
                            <div class="index_signleimg">
                                <img v-real-img="item.floor_img"/>
                            </div>
                        </div>
                        <!-- 楼层产品 -->
                        <div class="products product-swiper-container">
                            <ul class="list-group-row list-tab">
                                <li v-for="(chil,i) in item.children.slice(0,6)" :key="i" class="list-tab-item product-list-tab" :title="chil.title" style="font-weight: bold;font-size: 18px;width: 120px;" :class="{pitchOn:i==current}" @mouseenter="getChildGoods(i,chil.id,index)">{{chil.title}}</li>
                            </ul>
                            <div class="floor-category">
                                <ul class="list-group-row product-list clearfix">
                                    <li v-for="(goods,j) in item.goods" :key="j">
                                        <div class="product-container">
                                            <router-link :to="{path:'/GoodsDetail', query:{id:goods.id}}" target="_blank" :title="goods.title" class="img-container">
                                                <img v-real-img="goods.imgpath" src="../../assets/images/zwtp.jpg" :alt="goods.title" width="172" height="172">
                                            </router-link>
                                            <div class="product-name-container">
                                                <router-link :to="{path:'/GoodsDetail', query:{id:goods.id}}" target="_blank" :title="goods.title">
                                                    <span class="product-name">{{ goods.title }}</span>
                                                </router-link>
                                            </div>
                                            <div class="product-price-container">
                                                <span v-if="goods.tax_price && goods.tax_price > 0" class="price-sale">¥{{ goods.tax_price }}</span>
                                                <span v-else class="price-sale" style="font-size:14px">询价</span>
                                                <!-- <em>¥{$co.marketprice}</em> -->
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="brands" v-if="item.brand">
                            <div class="title">精选品牌</div>
                            <div class="brand-content">
                                <router-link :to="{path:'/Ppxq',query:{ bid:item.brand[0].id }}" target="_blank" >
                                    <img v-real-img="item.brand[0].img"/>
                                </router-link>
                                <router-link :to="{path:'/Ppxq',query:{ bid:item.brand[0].id }}" target="_blank" >
                                    <div class="brand-name">{{ item.brand[0].title }}</div>
                                </router-link>
                                <div class="brand-intro">
                                    {{ item.brand[0].content }}
                                </div>
                                <router-link class="logo-btn" target="_blank" :to="{path:'/Ppxq',query:{ bid:item.brand[0].id }}">
                                    <span>进入品牌专场</span>
                                    <i class="icon sprite-btn_arrow_r_normal"></i>
                                </router-link>
                            </div>
                            <div class="list-group-row logo-list">
                                <div v-for="(band,b) in item.brand.slice(1,7)" :key="b" class="logo-list-content" style="width:188px;height:97px">
                                    <router-link class="logo-link" :to="{path:'/Ppxq',query:{ bid:band.id }}" target="_blank" style="width:100%;height:97px;">
                                        <img v-real-img="band.img" style="width:100%"/>
                                        <div class="shadow" style="width:100%;height:100%;"></div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
        <div class="hxq_upload" v-show="enquiry">
            <div class="hxq_upload_box">
                <div class="hxq_upload_h clearfix">
                    <div class="hxq_upload_h_lt">平台询价</div>
                    <div class="hxq_upload_h_rt" @click="enquiryType"><em upload-box-close></em></div>
                </div>
                <div class="hxq_upload_b clearfix">
                    <div class="hxq_upload_b_lt">
                        <div class="hxq_upload_b_lt_txt">
                            <el-upload
                                class="avatar-uploader"
                                ref="upload"
                                list-type="picture-card"
                                :action = url
                                :on-change="handleChange"
                                :on-success="fileSuccess"
                                :auto-upload="false">
                                 <div slot="file" slot-scope="{file}">
                                    <img class="el-upload-list__item-thumbnail" src="../../assets/images/scwj.jpg">
                                    <span class="el-upload-list__item-actions">
                                        <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                                            <i class="el-icon-delete"></i>
                                        </span>
                                    </span>
                                </div>
                                <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                            </el-upload>
                        </div>
                    </div>
                    <a href="javascript:;" class="mbxz" @click="downloadht">模板下载</a>
                    <div class="hxq_upload_b_rt">
                        <div class="hxq_upload_filename">{{fileName}}</div>
                        <div class="hxq_upload_message">
                            <div class="hxq_upload_process"><span></span></div>
                            <div class="" upload-message>请选择word文件上传</div>
                            <div class="kiki">
                                <el-checkbox v-model="xjchecked"></el-checkbox> 请同意
                                <a href="javascript:;" class="scxy open_btn_xy">《平台询价文件上传协议》</a>
                            </div>
                        </div>
                        <div class="hxq_upload_submitbtn" v-if="xjchecked && isFile">
                            <a href="javascript: void(0);" @click="submitUpload">上传</a>
                        </div>
                        <div class="hxq_upload_submitbtn" v-else><a class="disable1" href="javascript: void(0);">上传</a></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import api from '@/api/index'
import news from '@/api/resources'
import flashsale from '@/api/flashsale'
import Header from '@/components/Header'
import Navigationzj from '@/components/Navigationzj'
import Footer from '@/components/Footer'
import apiConfig from '../../../config/api.config.js'
import { mapGetters } from 'vuex'

export default {
  components: {
    Header,
    Navigationzj,
    Footer
  },
  data () {
    return {
      bannerList: [],
      isTrue: false,
      brandList: [],
      brandCount: '',
      FlashList: [],
      FlashCount: '',
      SceneList: [],
      SceneCount: '',
      categoryGoods: [],
      current: 0,
      visible: true,
      sOrh: true,
      newsList: [],
      enquiry: false,
      xjchecked: false,
      disabled: false,
      fileName: '未选择文件',
      isFile: false,
      url: apiConfig.baseUrl + '/admin/Upload/Upload',
      day: 0,
      hou: 0,
      min: 0,
      sec: 0,
      ssec: 0,
      endTime: '',
      showFlashsale: false
    }
  },
  computed: {
    ...mapGetters(['current_user'])
  },
  created () {
    this.time()
  },
  mounted () {
    this.getBannerList()
    // this.getBrand()
    // this.getFlash()
    // this.getScene()
    this.getCategoryGoods()
    this.getNews()
    // this.getEndtime()
  },
  methods: {
    submitUpload () {
      this.$refs.upload.submit()
    },
    handleRemove (file, fileList) {
      this.$refs.upload.handleRemove(file)
      this.fileName = '未选择文件'
      this.isFile = false
    },
    handleChange (file, fileList) {
      if (this.$refs.upload.uploadFiles.length) {
        this.isFile = true
        this.fileName = file.name
      }
    },
    fileSuccess (response, file, fileList) {
      if (response && response.code === 20000) {
        this.enquiry = false
        this.uploadEnquiry(response.message)
      } else {
        this.$message.error(response)
      }
      this.handleRemove()
    },
    uploadEnquiry (message) {
      api.uploadEnquiry({ 'filepath': message }).then(res => {
        this.$message({
          message: '恭喜你，上传成功',
          type: 'success'
        })
      })
    },
    getNews () {
      news.getIndustryInfo({limit: 9, moduleid: 1, order: 'order_num', sort: 'asc', state: 'home'}).then(res => {
        this.newsList = res.items
      })
    },
    getBannerList () {
      api.bannerList().then(res => {
        this.bannerList = res.items
      })
    },
    getBrand () {
      // 获取热门品牌
      api.getBrand().then(res => {
        this.brandList = res.items
        this.brandCount = res.numbers
      })
    },
    getFlash () {
      // 获取秒杀商品
      api.getFlash().then(res => {
        this.FlashList = res.items
        this.FlashCount = res.numbers
      })
    },
    getScene () {
      // 获取场景采购
      api.getScene().then(res => {
        this.SceneList = res.items
        this.SceneCount = res.numbers
      })
    },
    getCategoryGoods () {
      // 楼层数据
      api.getCategoryGoods().then(res => {
        this.categoryGoods = res.items
      })
    },
    getChildGoods (i, id, index) {
      this.current = i
      api.getChildGoods({ 'id': id }).then(res => {
        this.categoryGoods[index].goods = res.items
      })
    },
    enquiryType () {
      if (this.current_user.id) {
        this.enquiry = !this.enquiry
      } else {
        this.$message.error('请先登录在进行询价')
      }
    },
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 6
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 6MB!')
      }
      return isLt2M
    },
    downloadht () {
      window.open('https://serv.nmzp.com/uploads/1/document/20210517/NMZP.xlsx')
    },
    getEndtime () {
      flashsale.getEndTime({ 'id': 1 }).then(res => {
        this.endTime = res.items.endtime
      })
    },
    time () {
      var that = this
      setInterval(function timestampToTime () {
        var date = (new Date(that.endTime)) - (new Date())
        // new Date当前的时间戳，也可以换成自定义的时间戳
        if (date > 0) {
          let time = date / 1000
          // 获取时、分、秒,毫秒
          that.day = parseInt(time / (24 * 3600)) < 10 ? ('0' + parseInt(time / (24 * 3600))) : parseInt(time / (24 * 3600))
          that.hou = parseInt((time % (60 * 60 * 24)) / 3600) < 10 ? ('0' + parseInt((time % (60 * 60 * 24)) / 3600)) : parseInt((time % (60 * 60 * 24)) / 3600)
          that.min = parseInt(((time % (60 * 60 * 24)) % 3600) / 60) < 10 ? ('0' + parseInt(((time % (60 * 60 * 24)) % 3600) / 60)) : parseInt(((time % (60 * 60 * 24)) % 3600) / 60)
          that.sec = parseInt(((time % (60 * 60 * 24)) % 3600) % 60) < 10 ? ('0' + parseInt(((time % (60 * 60 * 24)) % 3600) % 60)) : parseInt(((time % (60 * 60 * 24)) % 3600) % 60)
          that.ssec = parseInt(((date % (60 * 60 * 24)) % 3600) / 60) % 10
          that.showFlashsale = true
        } else {
          // 活动已结束，全部设置为'00'
          that.showFlashsale = false
          that.day = '00'
          that.hou = '00'
          that.min = '00'
          that.sec = '00'
        }
      }, 100)
    },
    zzjs () {
      this.$message.warning('正在建设中')
    }
  }
}
</script>
<style scoped>
    .brand-intro{
        height:96px!important;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        display: -webkit-box;
    }
    .hxq_upload {
        position: fixed;
        top: 50%;
        left: 50%;
        margin: -130px 0 0 -222px;
        z-index: 999999;
        width: 445px;
        height: 280px;
        background: #fff;
        border-radius: 5px;
        box-shadow: 0 0 10px 0 #999;
        filter: "progid:DXImageTransform.Microsoft.Shadow(color=#999999,direction=0,strength=2)";
    }
    .hxq_upload_h {
        height: 44px;
        line-height: 44px;
        background: #0079d7;
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
    }
    .hxq_upload_h_lt {
        float: left;
        margin: 0 0 0 10px;
        padding: 0 0 0 35px;
        font-size: 20px;
        color: #fff;
        background: url(../../assets/images/upload_img00.png) no-repeat left center;
    }
    .hxq_upload_h_rt {
        float: right;
        margin: 0 10px 0 0;
    }
    .hxq_upload_h_rt em {
        display: block;
        width: 20px;
        height: 44px;
        background: url(../../assets/images/upload_img01.png) no-repeat center;
        cursor: pointer;
    }
    .hxq_upload_h_rt em:hover {
        background: url(../../assets/images/upload_img02.png) no-repeat center;
    }
    .hxq_upload_b {
        padding: 28px 0 0 0;
        width: 410px;
        margin: 0 auto;
    }
    .hxq_upload_b_lt {
        position: relative;
        overflow: hidden;
        float: left;
        margin: 0 0 0 0;
        width: 148px;
        height: 148px;
        background: url(../../assets/images/upload_img03.png) no-repeat center;
        cursor: pointer;
    }
    .hxq_upload_b_lt:hover {
        background: url(../../assets/images/upload_img04.png) no-repeat center;
    }
    .hxq_upload_b_lt_txt {
        position: absolute;
        top: 0px;
        left: 0%;
        width: 100%;
        margin: 0 auto;
        text-align: center;
        font-size: 14px;
        color: #999;
        line-height: 60px;
    }
    .hxq_upload_b_rt {
        float: right;
        width: 240px;
        font-size: 14px;
        line-height: 30px;
        color: #666;
    }
    .hxq_upload_filename {
        height: 30px;
        padding: 5px 0 0 0;
        white-space: nowrap;
    }
    .hxq_upload_message {
        position: relative;
        margin: 10px 0 0 0;
    }
    .kiki {
        margin-top: 15px;
    }
    .hxq_upload_process {
        position: absolute;
        top: 32px;
        left: 0;
        display: none;
        width: 100%;
        height: 20px;
        line-height: 20px;
        background: #999;
    }
    .hxq_upload_process span {
        position: relative;
        overflow: hidden;
        display: block;
        width: 45%;
        height: 20px;
        color: #fff;
        font-size: 12px;
        text-align: center;
        background: #08da9d;
    }
    .hxq_upload_waring {
        padding: 0 0 0 25px;
        background: url(../../assets/images/upload_img05.png) no-repeat left center;
    }
    .hxq_upload_error {
        padding: 0 0 0 25px;
        color: red;
        background: url(../../assets/images/upload_img06.png) no-repeat left center;
    }
    .hxq_upload_success {
        padding: 0 0 0 25px;
        background: url(../../assets/images/upload_img07.png) no-repeat left center;
    }
    .mbxz {
        position: absolute;
        bottom: 19px;
        display: block;
        width: 138px;
        height: 33px;
        background: #315e99;
        text-align: center;
        font-size: 14px;
        line-height: 33px;
        color: #fff;
        border-radius: 4px;
    }
    .mbxz:hover {
        background: #5f92d9;
    }
    .kiki a:hover {
        color: #ee0000;
    }
    .hxq_upload_submitbtn a {
        display: block;
        height: 33px;
        line-height: 33px;
        text-align: center;
        color: #fff;
        background: #08da9d;
        border-radius: 5px;
        margin-top: 35px;
    }
    .hxq_upload_submitbtn a:hover {
        background: #00b5fa;
    }
    .hxq_upload_submitbtn a.disable1 {
        background: #999;
        cursor: not-allowed;
    }
    .hxq_upload_submitbtn a.disable2 {
        background: #00b5fa;
        cursor: not-allowed;
    }
    .webuploader-pick {
        height: 100%;
    }
    .hxq_upload_b_lt input {
        display: none;
    }
    .webuploader-dnd-over {
        background: url(../../assets/images/upload_img04.png) no-repeat center !important;
    }
    a {
        -webkit-tap-highlight-color: transparent;
        color: #1a1a1a;
    }
    .tj_index_r {
        width: 990px;
    }
    .index_big {
        border: none;
        overflow: hidden;
    }
    .index_big ul {
        margin: -9px -20px 0 0;
    }
    .index_big ul li {
        margin: 9px 9px 0 0;
        border: 1px solid #efefef;
    }
    .index_big ul li a {
        width: 188px;
        height: 97px;
    }
    .index_big ul li img {
        width: 100%;
        height: 100%;
    }
    .pitchOn {
        border-bottom: 2px solid #235d9d;
    }
    .recommend-each {
        background-color: rgb(248, 248, 248);
    }
    .logo-link{
        align-items: center;
        display: flex !important;
    }
    .themore{
        float: right;
        line-height: 30px;
        color: #efefef;
        font-weight: bold;
    }
    /* 秒杀 */
    .tj_index_l_skill {
        float: left;
        width: 230px;
    }
    .tj_index_l_skill a{
        float: left;
        width: 230px;
        height: 315px;
        background: url(../../assets/images/xsms.png) no-repeat;
        background-size: 100% 100%
    }
    .tj_index_l_skill .hotGoods-left-icon {
        margin: 0 auto;
        width: 40px;
        height: 58px;
        background: url(../../assets/images/flash.png) no-repeat;
        background-size: 100% 100%;
        margin-top: 120px;
        -webkit-animation: twinkling 0.5s infinite alternate;
    }
    @keyframes twinkling {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(1.3);
    }
    }
    .tj_index_l_skill .hotGoods-left-time {
        line-height: 1.15;
        padding: 35px 0 0;
        color: #fff;
        font-size: 16px;
        text-align: center;
        font-style: normal;
    }
    .t-wrap {
        padding-top: 17px;
        text-align: center;
    }
    .t-wrap span {
        position: relative;
        display: inline-block;
    }
    .t-wrap span em {
        display: block;
        padding: 0 9px;
        border-radius: 4px;
        background: #000;
        font-style: normal;
        font-size: 24px;
        line-height: 40px;
        color: #fff;
    }
    .t-wrap span i{
        /* display: none; */
        position: absolute;
        top: 43px;
        left: 0;
        width: 100%;
        text-align: center;
        font-size: 12px;
        font-style: normal;
    }
    .tj_index_r_skill {
        width: 961px;
        position: relative;
        float: right!important;
    }
    .index_big_skill {
        border: none;
        overflow: hidden;
    }
    .index_big_skill ul {
        margin: -9px -20px 0 0;
        padding-left: 1px;
    }
    .index_big_skill ul li {
        float: left;
        margin: 9px -1px 0 0;
        border: 1px solid #efefef;
    }
    .index_big_skill ul li a {
        width: 238px;
        height: 313px;
        display: block;
        overflow: hidden;
    }
    .index_big_skill .img-box {
        display: block;
        width: 160px;
        height: 160px;
        margin: 25px 35px 15px;
    }
    .index_big_skill img {
        width: 100%;
        height: 100%;
        transition: all 0.5s;
        -webkit-transition: all 0.5s;
        -moz-transition: all 0.5s;
        transform: scale(1);
        -webkit-transform: scale(1);
        -moz-transform: scale(1);
    }
    .index_big_skill .goodsName {
        height: 16px;
        line-height: 16px;
        color: #222;
        width: 190px;
        margin: 0 20px 20px;
        font-size: 14px;
        display: inline-block;
        cursor: pointer;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .index_big_skill .hot-price {
        box-sizing: border-box;
        display: block;
        width: 190px;
        margin: 0 20px 15px;
        font-size: 14px;
        height: 34px;
        border: 2px solid #ed2920;
        background: #ed2920;
        color: #fff;
        border-radius: 2px;
        text-align: left;
    }
    .index_big_skill .p-price {
        display: inline-block;
        height: 30px;
        font-size: 18px;
        line-height: 30px;
        font-style: normal;
        padding-left: 14px;
        font-weight: 700;
        float: left;
        color: #fff;
    }
    .index_big_skill .p-price i {
        font-style: normal;
        font-size: 12px;
    }
    .index_big_skill .c-price {
        float: right;
        border-bottom: 30px solid #fff;
        border-left: 10px solid transparent;
        height: 0;
        width: 80px;
        font-style: normal;
        font-size: 18px;
        font-size: 14px;
        line-height: 30px;
        color: rgba(0,0,0,.45);
        text-align: center;
        text-decoration: line-through;
    }
    /* 秒杀 */
    /* 丹弗斯 永磁电机 维修 */
    .repair {
        margin-top: 10px;
    }
    .repair li{
        float: left;
        width: 291px;
        height: 120px;
        margin-right: 12px;
        background: #eee;
        box-sizing: border-box;
    }
    .repair li:last-child{
        margin-right: 0;
    }
    .repair li a{
        position: relative;
        display: block;
        width: 100%;
        height: 100%;
    }
    .repair li a img{
        display: block;
        width: 100%;
        height: 100%;
    }
    /* 丹弗斯 永磁电机 维修 */
</style>



// WEBPACK FOOTER //
// src/view/index/index.vue